import React from "react";
import { Controller } from "react-hook-form";

import AuthButton from "../AuthButton";

import { compliance, termsLink } from "../../../../constants/link";
import { InputsRules } from "../../../../constants/auth";

import { Container, Error, Link, StyledCheckbox, Wrapper } from "./styles";

const AuthRegistrationFooter = ({
  onSubmit,
  isValid,
  isLoading,
  control,
  error,
}) => (
  <Container>
    <Wrapper>
      <Controller
        control={control}
        rules={{ required: InputsRules.required }}
        name="policy"
        render={({ field }) => (
          <StyledCheckbox $isError={error} {...field} checked={field.value}>
            By signing up, you agree to the Cart2Cart{" "}
            <Link href={termsLink} target="_blank">
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link href={compliance} target="_blank">
              GDPR Compliance.
            </Link>
          </StyledCheckbox>
        )}
      />
      {error && <Error>{error}</Error>}
    </Wrapper>

    <AuthButton onSubmit={onSubmit} isLoading={isLoading} isValid={isValid}>
      Sign Up
    </AuthButton>
  </Container>
);

export default AuthRegistrationFooter;
